import { createContext, useContext } from 'react'

export type ChooseDataSourceContextValue = {
  openChooseDataSource: (
    nodeId: string,
    connectorId: string | undefined,
    groupId?: string
  ) => void
  openIntegrationSettings: (nodeId: string, connectorId: string | undefined) => void
  openTransformationSettings: (nodeId: string, connectorId: string | undefined) => void
}

export const ChooseDataSourceContext = createContext<ChooseDataSourceContextValue | null>(null)

export function useChooseDataSource() {
  return useContext(ChooseDataSourceContext)
}
